import React, { useEffect, useState } from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import {
  capitalizeEachWord,
  extractAdminOverview,
  showSwal,
} from "../../AppManager";
import { FaDownload, FaFileExcel, FaSpinner } from "react-icons/fa6";
import { axios, downloadBaseURL } from "../../Auth";

export default function Analysis() {
  const { record } = useOutletContext();
  const [analysis, setAnalysis] = useState({
    total: 0,
    "Believers Class": { total: 0 },
    "Baptismal Class": { total: 0 },
    "Workers in Training": { total: 0 },
  });
  const [download, setDownload] = useState({ name: "", state: "", link: "" });
  const { type } = useParams();

  document.title = `${capitalizeEachWord(type)} Anaylsis`;

  const generatorAll = async () => {
    try {
      setDownload({ name: "Total", state: "loading", link: "" });
      const formdata = new FormData();

      let url;
      if (type === "students") {
        formdata.append(
          "believers",
          JSON.stringify(
            Object.keys(analysis["Believers Class"])
              .filter((key) => key !== "total")
              .sort()
          )
        );
        formdata.append(
          "baptismal",
          JSON.stringify(
            Object.keys(analysis["Baptismal Class"])
              .filter((key) => key !== "total")
              .sort()
          )
        );
        formdata.append(
          "workers",
          JSON.stringify(
            Object.keys(analysis["Workers in Training"])
              .filter((key) => key !== "total")
              .sort()
          )
        );

        formdata.append("generate_studs", "njknxankjndkjan");
        url = "php/downloadStudents.php";
      } else {
        formdata.append("generate_teachs", "mdo34ixj 43p");
        url = "php/downloadTeachers.php";
      }
      const send = await axios.post(url, formdata, {
        mode: "cors",
        Headers: {
          "Content-Type": "application/json",
        },
      });

      if (send.data.message === "success") {
        setDownload((old) => ({
          ...old,
          state: "ready",
          link: downloadBaseURL + send.data.link,
        }));
      } else {
        showSwal("error", "Download Failed");
        setDownload({ name: "", state: "", link: "" });
      }
    } catch (error) {
      showSwal("error", "Download Failed");
      setDownload({ name: "", state: "", link: "" });
    }
  };

  const generator = async (name) => {
    try {
      setDownload({ name, state: "loading", link: "" });
      const formdata = new FormData();
      formdata.append("name", name);

      let url;
      if (type === "students") {
        formdata.append(
          "data",
          JSON.stringify(
            Object.keys(analysis[name])
              .filter((key) => key !== "total")
              .sort()
          )
        );

        formdata.append("generate_tclass_studs", "mxwnjsekwq");
        url = "php/downloadTClassStudents.php";
      } else {
        formdata.append("generate_tclass_teachs", "mjni7b76v4xd");
        url = "php/downloadTClassTeachers.php";
      }
      const send = await axios.post(url, formdata, {
        mode: "cors",
        Headers: {
          "Content-Type": "application/json",
        },
      });

      if (send.data.message === "success") {
        setDownload((old) => ({
          ...old,
          state: "ready",
          link: downloadBaseURL + send.data.link,
        }));
      } else {
        showSwal("error", "Download Failed");
        setDownload({ name: "", state: "", link: "" });
      }
    } catch (error) {
      showSwal("error", "Download Failed");
      setDownload({ name: "", state: "", link: "" });
    }
  };

  useEffect(() => {
    setAnalysis(extractAdminOverview(record).analysis[type]);
  }, [record, type]);

  return (
    <div className="overview-class admin-overview-class">
      <h1 className="heading1">{capitalizeEachWord(type)} Analysis</h1>
      <div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Total:
          </h1>
          <span>
            <span>{analysis.total}</span>
            {download.name === "Total" ? (
              download.state === "ready" ? (
                <a
                  href={download.link}
                  download
                  onClick={() => {
                    setDownload({ name: "", state: "", link: "" });
                  }}
                >
                  <FaFileExcel />
                </a>
              ) : (
                <span>
                  <FaSpinner className="spinner" />
                </span>
              )
            ) : (
              <span style={{ color: "#002f63", cursor: "pointer" }}>
                <FaDownload onClick={generatorAll} />
              </span>
            )}
          </span>
        </div>
        {["Believers Class", "Baptismal Class", "Workers in Training"].map(
          (tclass, index) => (
            <div key={`${tclass}_${index}`}>
              <h1 className="heading3" style={{ textAlign: "left" }}>
                {tclass}:
              </h1>
              <span>
                {type === "students" ? (
                  <Link to={tclass}>{analysis[tclass].total}</Link>
                ) : (
                  <span>{analysis[tclass].total}</span>
                )}
                {download.name === tclass ? (
                  download.state === "ready" ? (
                    <a
                      href={download.link}
                      download
                      onClick={() => {
                        setDownload({ name: "", state: "", link: "" });
                      }}
                    >
                      <FaFileExcel />
                    </a>
                  ) : (
                    <span>
                      <FaSpinner className="spinner" />
                    </span>
                  )
                ) : (
                  <span style={{ color: "#002f63", cursor: "pointer" }}>
                    <FaDownload
                      onClick={() => {
                        generator(tclass);
                      }}
                    />
                  </span>
                )}
              </span>
            </div>
          )
        )}
      </div>
    </div>
  );
}
